import React from "react";
import { InputWrapper } from "../../../../components/Input/InputWrapper";
import { InputLabel } from "../../../../components/Input/InputLabel";
import {
  FieldGrid,
  FieldGroup,
  ReadOnlyField,
} from "../../../../components/OrgShell/FieldGroup";
import { ShippingSection } from "../../../customer-update/component/sections/shipping-section.component";
import { DetailsForm } from "../../../customer-create/components/organization-details-form.component";

interface VendorDetailsSectionProps {
  form: DetailsForm;
  onChange: (form: DetailsForm) => void;
  navNumber?: string;
  shippingDiffers: boolean;
  onShippingDiffersChange: (differs: boolean) => void;
}

/**
 * The vendor's own company details: read-only company fields (they are
 * managed in the ERP system) plus the editable shipping address that keeps
 * the existing save round-trip.
 */
export function VendorDetailsSection({
  form,
  onChange,
  navNumber,
  shippingDiffers,
  onShippingDiffersChange,
}: VendorDetailsSectionProps) {
  return (
    <div className="space-y-8">
      <FieldGroup
        title="Company details"
        description="Company details are managed in the ERP system (NAV) and cannot be edited here."
      >
        <FieldGrid>
          <InputWrapper>
            <InputLabel>Company name</InputLabel>
            <ReadOnlyField value={form.name} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>NAV number</InputLabel>
            <ReadOnlyField value={navNumber} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Company email</InputLabel>
            <ReadOnlyField value={form.email} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Company phone</InputLabel>
            <ReadOnlyField value={form.phone} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>CVR</InputLabel>
            <ReadOnlyField value={form.cvr} />
          </InputWrapper>
        </FieldGrid>
      </FieldGroup>

      <FieldGroup title="Address">
        <FieldGrid>
          <InputWrapper>
            <InputLabel>Address</InputLabel>
            <ReadOnlyField value={form.address} />
          </InputWrapper>
          <div className="grid grid-cols-2 gap-x-4">
            <InputWrapper>
              <InputLabel>Postcode</InputLabel>
              <ReadOnlyField value={form.postCode} />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>City</InputLabel>
              <ReadOnlyField value={form.city} />
            </InputWrapper>
          </div>
          <InputWrapper>
            <InputLabel>Country</InputLabel>
            <ReadOnlyField value={form.country} />
          </InputWrapper>
        </FieldGrid>
      </FieldGroup>

      <ShippingSection
        form={form}
        onChange={(patch) => onChange({ ...form, ...patch })}
        differs={shippingDiffers}
        onDiffersChange={onShippingDiffersChange}
      />
    </div>
  );
}
